<template>
  <div>
    <AuBreadcrumb
      :pages="breadcrumb"
    />
    <Form>
      <template #header>
        <span v-if="stage===1">
          {{ $t("buyForm.title") }}
        </span>
        <span v-else>
          {{ $t("buyForm.third.title.1") }}
        </span>
      </template>

      <div v-if="hasAccessToDeposit">
        <SecondStage
          v-if="stage===1"
          @next="setToken"
          @setAddress="value => address = value"
        />
        <ThirdStage
          v-if="stage===2"
          :address="address"
          :token="token"
          :url-scan="urlScan"
          @next="toMainPage"
        />
      </div>
      <div v-else>
        <div>
          {{ accessDenyText }}
        </div>

        <div class="d-flex gap-2">
          <RouterLink
            v-for="(buttonOption, index ) in accessDenyButtonsOptions"
            :key="index"
            :to="buttonOption.to"
          >
            <AuButton
              class="mt-2"
              type="primary"
              center
              width="200px"
            >
              <div>
                {{ buttonOption.text }}
              </div>
            </AuButton>
          </RouterLink>
        </div>
      </div>
    </Form>
  </div>
</template>

<script>
import SecondStage from "@/components/buyForm/SecondStage";
import ThirdStage from "@/components/buyForm/ThirdStage";
import { checkAccess, getAccessDeniedReasons, getAccessDeniedReasonsText, reasons, scope } from "@/help/accessData";

import { mapGetters } from "vuex";

export default {
  name: "BuyForm",
  components: { ThirdStage, SecondStage },
  data() {
    return {
      breadcrumb: [
        { key: 0, name: this.$t("router.pages.dashboard"), path: "/" },
        { key: 1, name: this.$t("router.pages.briefcase"), path: "/my-assets" }
      ],
      stage: 1,
      address: "",
      token: "",
      urlScan: "",
      accessDenyText: "",
      accessDenyButtonsOptions: []
    };
  },

  computed: {
    ...mapGetters({
      defaultTokenMnemonic: "defaultToken/defaultTokenMnemonic",
      arrEth: "ethAddresses"
    }),

    isEqual() {
      return /equal/i.test(process.env.VUE_APP_TITLE) ? "Equal" : "";
    },

    platform() {
      return process.env.VUE_APP_PLATFORM;
    },

    hasAccessToDeposit() {
      return checkAccess(scope.deposit);
    }
  },

  created() {
    this.setAccessDeniedReasons();
  },

  methods: {
    setToken(arg) {
      this.stage++;
      this.token = arg.tokenName;
      this.urlScan = arg.urlScan;
    },

    toMainPage() {
      this.$router.push({ name: "base" });
    },

    setAccessDeniedReasons() {
      const denyReasons = getAccessDeniedReasons(scope.deposit);

      const textParams = { platform: this.platform };
      this.accessDenyText = getAccessDeniedReasonsText(scope.deposit, textParams);

      for (const reason of denyReasons) {
        switch (reason) {
          case reasons.email:
            this.accessDenyButtonsOptions.push({
              to: "/user",
              text: this.$t("access.solutions.verifyEmail")
            });
            break;
          case reasons.wallet:
            this.accessDenyButtonsOptions.push({
              to: "/wallet-verification",
              text: this.$t("access.solutions.connectWallet")
            });
            break;
          case reasons.kyc:
            this.accessDenyButtonsOptions.push({
              to: "/kyc",
              text: this.$t("access.solutions.kycComplete")
            });
            break;
          default:
            break;
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.buy-panel {
  width: 100%;
  padding: 20px;
}
.buy-header {
  font-size: 24px;
  border-bottom: 1px solid var(--color-70);
  padding-bottom: 15px;
  width: 100%;
  display: block;
}
</style>